<template>
  <div class="form-wrapper">
    <section
      v-for="sectionIndex in 2"
      :key="sectionIndex"
      class="settings-section"
    >
      <v-skeleton-loader
        type="heading"
        class="mb-4"
        width="260"
      />
      <div class="description-skeleton mb-4">
        <v-skeleton-loader
          type="text"
          width="100%"
        />
      </div>
      <v-skeleton-loader
        type="text"
        width="180"
        height="40"
      />
    </section>
  </div>
</template>

<style scoped lang="less">
.form-wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  border-radius: 10px;
  background: @white;
  padding: 28px 40px 40px;
}

.settings-section {
  width: 100%;
}

.description-skeleton {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 560px;
}

</style>
